import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import './scss/steps.scss';

const Steps = ({ currentStep }) => {
  const steps = [];

  for (let i = 1; i < 4; i++) {
    steps.push(<Icon key={ i } name={ `circle${currentStep !== i ? ' outline' : ''}` } size="small" />);
  }

  return (
    <div className="steps">
      { steps.map(x => (x)) }
    </div>
  );
};

Steps.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/Setup/components/Steps.js